<template>
      <div v-if="show"  class="col-md-12">
          <div class="card card-default">
            <div class="card-header">
                  <div class="h5 mt-2">🎉 Welcome, let's get started!</div>
            </div>

            <div class="card-body">     
                  <p>Thank you for choosing Site Command! We hope you enjoy using it and if you have any feedback, we'd love to hear it.</p>
                  <p>If you have any questions, please feel free to <a href="mailto:tom@sitecommandapp.com?subject=Site Command">email me</a> directly.</p>
                  <p>Talk soon!</p>

                  <div class="row">
                        <div class="col-md-1">
                              <img src="https://s3.amazonaws.com/sitecommand/changeorders/tom-headshot.jpg" class="coming-soon-tom-pic">
                        </div>
                        <div class="col-md-5 pl-0">
                              <span class="coming-soon-sign-off-name">Tom Redman</span> <br>
                              <span class="coming-soon-sign-off-title">Founder, Site Command</span>
                        </div>
                  </div>
            </div>
          </div>
      </div>
</template>

<script>
    export default {
        created: function() {
            let vm = this;
            Bus.$on('show-welcome-message', function (show) {
                vm.show = show;
                return true;
            });
        },

        mounted: function() {

        },

        data: function() {
            return {
                show: false,
            };
        },

        computed: {
        },

        methods: {
        }
    }
</script>
